import React, { useEffect, useState } from "react";
import { createData } from "../../utility/adminApi";
import CancelIcon from "@mui/icons-material/Cancel";
import SelectLabels from "../../components/SelectLabels";
import { adminAxios } from "../../axiosInstance";
function AddUser({ setIsLoading, setAddtab, fetchUsers, currentPage }) {
  const [formData, setFormData] = useState({
    role_id: "",
    firstname: "",
    lastname: "",
    email: "",
    address: "",
    phoneno: "",
    password: "",
    confirmPassword: "",
  });
  const [roleDetail, setRoleDetail] = useState();
  const [loading, setLoading] = useState(false);

  const fetchProductData = async (page) => {
    try {
      const response = await adminAxios.get("roles");
      const data = response?.data?.data;
      setRoleDetail(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleRowChange = (id) => {
    setFormData((prevData) => ({ ...prevData, role_id: id }));
  };

  const handleChange = async (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    const response = await createData("users/store", formData);
    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      fetchUsers(currentPage);
      setLoading(false);
      setAddtab(false);
    }
  };
  useEffect(() => {
    fetchProductData();
  }, []);

  return (
    <div className="bg-white  p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setAddtab(false)}
        />
      </div>
      <h3 className="text-2xl font-medium text-center">Add New User</h3>
      <form
        onSubmit={handleSubmit}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex flex-col flex-wrap justify-center lg:flex-row gap-6 ">
          <div className="flex flex-col lg:w-[400px]">
            <label htmlFor="">Roles</label>
            <SelectLabels
              categoryData={roleDetail}
              text="Select a Role"
              valueKey="id"
              labelKey="name"
              onSelectChange={handleRowChange}
            />
          </div>
          <div className="flex  flex-col">
            <label htmlFor="">Email</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Email"
              type="text "
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">First Name</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="First Name"
              type="text "
              name="firstname"
              value={formData.firstname}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">Last Name</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Last Name"
              type="text "
              name="lastname"
              value={formData.lastname}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">Address</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Address"
              type="text "
              name="address"
              // id="email"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">Phone Number</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Phone Number"
              type="text "
              name="phoneno"
              // id="email"
              value={formData.phoneno}
              onChange={handleChange}
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Password</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[400px]"
              placeholder="Password"
              type="password"
              // id="email"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">Confirm Password</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[400px]"
              placeholder="Confirm Password"
              type="password"
              // id="email"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500"
        >
          {loading ? "Adding User..." : "Add User"}
        </button>
      </form>
    </div>
  );
}

export default AddUser;
